var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',[_c('BaseCardBody',[_c('p',{staticClass:"mb-4"},[_vm._v("No active facebook integration was found.")]),_c('BaseButton',{attrs:{"primary":"","tag":"a","href":_vm.connectUrl}},[_vm._v(" Connect Facebook ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }